import createDOMPurify from 'dompurify';

const textStyles = new Set([
  'color',
  'background-color',
  'font-size',
  'font-family',
  'font-weight',
  'font-style',
  'text-align',
  'text-decoration',
  'text-indent',
  'line-height',
  'letter-spacing',
  'white-space',
  'vertical-align',
  'list-style-type',
  'border',
  'border-color',
  'border-width',
  'border-style',
  'border-collapse',
  'padding',
  'margin',
  'margin-top',
  'margin-bottom',
  'margin-left',
  'margin-right',
  'width',
  'height',
  'max-width'
]);

export function createRichTextSanitizer(browserWindow) {
  const purifier = createDOMPurify(browserWindow);
  purifier.addHook('uponSanitizeAttribute', (_node, attribute) => {
    if (attribute.attrName === 'href' || attribute.attrName === 'src') {
      try {
        const address = new URL(
          attribute.attrValue,
          attribute.attrName === 'src' ? browserWindow.location.href : undefined
        );
        attribute.keepAttr = /^https?:$/.test(address.protocol);
      } catch (_) {
        attribute.keepAttr = false;
      }
    }
    if (attribute.attrName === 'style') {
      // 保留编辑器常用排版；不接入可加载资源或覆盖页面的CSS属性。
      const style = browserWindow.document.createElement('span').style;
      style.cssText = attribute.attrValue;
      attribute.attrValue = Array.from(style)
        .filter((name) => textStyles.has(name))
        .map((name) => `${name}:${style.getPropertyValue(name)}`)
        .join(';');
      attribute.keepAttr = Boolean(attribute.attrValue);
    }
  });
  return (content) =>
    purifier.sanitize(String(content ?? ''), {
      USE_PROFILES: { html: true },
      FORBID_TAGS: ['style'],
      FORBID_ATTR: ['srcset']
    });
}

let sanitize;
export function sanitizeRichText(content) {
  if (typeof window === 'undefined') {
    // 无DOM环境不放行未经净化的HTML。
    return String(content ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }
  if (!sanitize) sanitize = createRichTextSanitizer(window);
  return sanitize(content);
}
